<template>
  <b-row>
    <div class="col-12 col-lg-9">
      <b-card class="mb-3" :header="heading" no-body>
        <div class="card-body">
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="Name:">
                <b-form-input
                  id="form-input-name"
                  name="form-input-name"
                  v-model="itemForm.name"
                  v-validate="{ required: true, min: 1 }"
                  :state="validateState('form-input-name')"
                  data-vv-as="Name"
                  />
                <b-form-invalid-feedback
                  id="form-input-name-feedback"
                >
                  {{ veeErrors.first('form-input-name') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Brand:">
                <b-v-select
                  id="form-input-brandId"
                  name="form-input-brandId"
                  v-validate="{ required: true }"
                  :state="validateState('form-input-brandId')"
                  v-model="itemForm.brandId"
                  :searchable="true"
                  :options="brandsList"
                />
                <b-form-invalid-feedback id="form-input-brandId-feedback">
                  {{ veeErrors.first('form-input-brandId') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Warehouse:">
                <b-v-select
                  id="form-input-warehouseId"
                  name="form-input-warehouseId"
                  v-validate="{ required: false }"
                  :state="validateState('form-input-warehouseId')"
                  v-model="itemForm.warehouseId"
                  :searchable="true"
                  :options="warehousesList"
                />
                <b-form-invalid-feedback id="form-input-warehouseId-feedback">
                  {{ veeErrors.first('form-input-warehouseId') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="External ID:">
                <b-form-input
                  id="form-input-externalId"
                  name="form-input-externalId"
                  v-model="itemForm.externalId"
                  :disabled="true"
                  :state="validateState('form-input-externalId')"
                  data-vv-as="External ID"
                  />
                <b-form-invalid-feedback id="form-input-externalId-feedback">
                  {{ veeErrors.first('form-input-externalId') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <b-card class="mb-3" header="Dimensions" no-body>
        <div class="card-body">
          <b-row>
            <b-col cols="12" md="4">
              <b-form-group label="Length (inches):">
                <b-form-input
                  id="form-input-length"
                  name="form-input-length"
                  v-model="itemForm.length"
                  type="number"
                  step="0.01"
                  min="0"
                  v-validate="{ required: true, min_value: 0 }"
                  :state="validateState('form-input-length')"
                  data-vv-as="Length"
                  />
                <b-form-invalid-feedback id="form-input-length-feedback">
                  {{ veeErrors.first('form-input-length') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="Width (inches):">
                <b-form-input
                  id="form-input-width"
                  name="form-input-width"
                  v-model="itemForm.width"
                  type="number"
                  step="0.01"
                  min="0"
                  v-validate="{ required: true, min_value: 0 }"
                  :state="validateState('form-input-width')"
                  data-vv-as="Width"
                  />
                <b-form-invalid-feedback id="form-input-width-feedback">
                  {{ veeErrors.first('form-input-width') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="Height (inches):">
                <b-form-input
                  id="form-input-height"
                  name="form-input-height"
                  v-model="itemForm.height"
                  type="number"
                  step="0.01"
                  min="0"
                  v-validate="{ required: true, min_value: 0 }"
                  :state="validateState('form-input-height')"
                  data-vv-as="Height"
                  />
                <b-form-invalid-feedback id="form-input-height-feedback">
                  {{ veeErrors.first('form-input-height') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <b-card class="mb-3" header="Weight & Volume" no-body>
        <div class="card-body">
          <b-row>
            <b-col cols="12" md="4">
              <b-form-group label="Total Weight (lbs):">
                <b-form-input
                  id="form-input-weight"
                  name="form-input-weight"
                  v-model="itemForm.weight"
                  type="number"
                  step="0.01"
                  min="0"
                  v-validate="{ required: true, min_value: 0 }"
                  :state="validateState('form-input-weight')"
                  data-vv-as="Weight"
                  />
                <b-form-invalid-feedback id="form-input-weight-feedback">
                  {{ veeErrors.first('form-input-weight') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="Minimum Volume (cubic inches):">
                <b-form-input
                  id="form-input-minVolume"
                  name="form-input-minVolume"
                  v-model="itemForm.minVolume"
                  type="number"
                  step="0.01"
                  min="0"
                  v-validate="{ required: false, min_value: 0 }"
                  :state="validateState('form-input-minVolume')"
                  data-vv-as="Minimum Volume"
                  />
                <b-form-invalid-feedback id="form-input-minVolume-feedback">
                  {{ veeErrors.first('form-input-minVolume') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="Maximum Volume (cubic inches):">
                <b-form-input
                  id="form-input-maxVolume"
                  name="form-input-maxVolume"
                  v-model="itemForm.maxVolume"
                  type="number"
                  step="0.01"
                  min="0"
                  v-validate="{ required: false, min_value: 0 }"
                  :state="validateState('form-input-maxVolume')"
                  data-vv-as="Maximum Volume"
                  />
                <b-form-invalid-feedback id="form-input-maxVolume-feedback">
                  {{ veeErrors.first('form-input-maxVolume') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <aside class="col-12 col-lg-3">
      <b-card header="Actions">
        <b-button
          :disabled="savingItem"
          variant="primary"
          block
          type="submit"
          @click="SaveForm"
        >
          <span v-if="savingItem">Saving...</span>
          <span v-else>Save Changes</span>
        </b-button>
        <router-link
          :disabled="savingItem"
          class="mt-2 btn btn-block btn-outline-danger"
          :to="{ name: 'BrandFulfillmentBoxes.Index' }"
        >
          <span>Cancel</span>
        </router-link>
      </b-card>
    </aside>
  </b-row>
</template>

<script>
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [crudMixinGen('brandFulfillmentBoxes'), myCommonDataMixin],
  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data: () => ({
    heading: 'Brand Fulfillment Box Form'
  }),

  computed: {
  },

  mounted() {
    if (this.id) {
      this.ResetForm();
      this.LoadItem(this.id)
    } else {
      this.ResetForm();
    }
  },

  watch: {
  },

  methods: {
    SaveForm() {
      this.savingItem = true;
      this.SaveItem()
        .then(resp => {
          this.ResetForm();
          this.$swal({ title: 'Item Was Saved!', icon: 'success' });
          this.$router.push({
            name: 'BrandFulfillmentBoxes.Index'
          });
        })
        .catch(err => {
          this.savingItem = false;
          if (err.response && err.response.data && err.response.data.errorMessage) {
            this.$swal({ title: err.response.data.errorMessage, icon: 'error' });
          } else {
            this.$swal({ title: 'Item Was NOT Saved!', icon: 'error' });
          }
        });
    }
  }
};
</script>